// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import store from './vuex/store'
import MintUi from "mint-ui"
import 'mint-ui/lib/style.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/common.css'

Vue.config.productionTip = false;
Vue.use(MintUi);
Vue.use(Vuex);
Vue.use(ElementUI);
global.HOST = '/api'

localStorage.removeItem('recommendDataList');
localStorage.removeItem('userDataList');
localStorage.removeItem('specialSex');

localStorage.setItem('params', JSON.stringify(window.location.search));
global.PARAMS = JSON.parse(localStorage.getItem('params'));

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js